import {
  GET_PAGES_SUCCESS,
  CREATE_PAGE,
  CREATE_PAGE_SUCCESS,
  CLEAR_LAST_CREATED_PAGE_ID,
  CLEAR_ACTUAL_PAGE_ID,
} from './constants'


export function getPagesSuccess(payload) {
  return {
    type: GET_PAGES_SUCCESS,
    payload,
  }
}

export function createNewPageAction(payload) {
  return {
    type: CREATE_PAGE,
    payload,
  }
}


export function createNewPageSuccess(payload) {
  return {
    type: CREATE_PAGE_SUCCESS,
    payload,
  }
}

export function clearLastCreatedPageIdAction() {
  return {
    type: CLEAR_LAST_CREATED_PAGE_ID,
  }
}

export function clearActualPageIdAction() {
  return {
    type: CLEAR_ACTUAL_PAGE_ID,
  }
}
